<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="paymentSchedules">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลกำหนดการนัดชำระเงิน</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"
                             @click="onPressedActiveAddPaymentSchedule()">เพิ่มข้อมูล
                  </vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่นัดชำระ</vs-th>
              <vs-th>จำนวน</vs-th>
              <vs-th>หมายเหตุ</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-status">สถานะ</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.paymentDateLocalTh }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmount | numberFormat }}</vs-td>
                <vs-td>{{ row.paymentRemark || '-' }}</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.status === IStatus.enabled ? 'success' : 'danger'">
                    {{ statusName(row.status) }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="แก้ไขข้อมูลกำหนดการนัดชำระเงิน">
                      <vs-button class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit"
                                 @click="onPressedActiveUpdatePaymentSchedule(row)"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูลกำหนดการนัดชำระเงิน">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"
                                 @click="onPressedDelPaymentSchedule(row.id)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup
      :active.sync="paymentScheduleModal.active"
      :title="paymentScheduleModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="วันที่นัดชำระ" rules="required" v-slot="{ errors }">
                  <label class="text-sm">วันที่นัดชำระ*</label>
                  <flat-pickr :config="configDatePaymentSchedule" class="w-full"
                              v-model="paymentScheduleModal.paymentDate"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }">
                  <label class="text-sm">จำนวน*</label>
                  <vs-input type="number" class="w-full" v-model="paymentScheduleModal.paymentAmount"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider name="หมายเหตุ" rules="" v-slot="{ errors }">
                  <label class="vs-input--label">หมายเหตุ</label>
                  <vs-textarea v-model="paymentScheduleModal.paymentRemark" rows="5"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptPaymentSchedule">บันทึก</vs-button>
        <vs-button color="danger" @click="paymentScheduleModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import moment from "moment";
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IStatus} from "@/constants/interface";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'PaymentScheduleTab',
  components: {
    flatPickr
  },
  data() {
    return {
      paymentScheduleModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลกำหนดการนัดชำระเงิน',
        id: null,
        paymentDate: moment().format('DD-MM-YYYY'),
        paymentAmount: 0,
        paymentRemark: "",
        status: IStatus.enabled,
      },
    };
  },
  computed: {
    ...mapAccountingFields(['contractDetail', 'contractDetailPaymentSchedules']),
    IStatus() {
      return IStatus;
    },
    configDatePaymentSchedule() {
      let minDate = null
      let maxDate = null

      if (this.contractDetail && this.contractDetail.loan && this.contractDetail.loan.lastUpdate) {
        const lastUpdateDate = moment(this.contractDetail.loan.lastUpdate).add(1, 'days')
        minDate = lastUpdateDate.format('DD-MM-YYYY')
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    paymentSchedules() {
      if (!this.contractDetailPaymentSchedules) return null;
      return [...this.contractDetailPaymentSchedules]
        .sort(({paymentDate: aPaymentDate, createdAt: aCreatedAt}, {
          paymentDate: bPaymentDate,
          createdAt: bCreatedAt
        }) => {
          const paymentDateDiff = new Date(bPaymentDate) - new Date(aPaymentDate);
          if (paymentDateDiff !== 0) {
            return paymentDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((paymentSchedule) => {
          const {
            id,
            paymentDate,
            paymentAmount,
            paymentRemark,
            status,
            createdAt,
            createdAtLocalTh,
            createByFullName,
            paymentDateLocalTh,
            processed,
          } = paymentSchedule;
          return {
            id,
            paymentDate,
            paymentAmount,
            paymentRemark,
            status,
            createdAt,
            createdAtLocalTh,
            createByFullName,
            paymentDateLocalTh,
            processed,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['createContractDetailPaymentSchedule', 'updateContractDetailPaymentSchedule', 'deleteContractDetailPaymentSchedule']),
    statusName(status) {
      if (status === IStatus.enabled) return 'ใช้งาน';
      if (status === IStatus.disabled) return 'ปิดใช้งาน';
      return status || '-';
    },
    onPressedActiveAddPaymentSchedule() {
      this.paymentScheduleModal = {
        active: true,
        type: 'add',
        title: 'เพิ่มข้อมูลกำหนดการนัดชำระเงิน',
        id: null,
        paymentDate: moment().format('DD-MM-YYYY'),
        paymentAmount: 0,
        paymentRemark: "",
        status: IStatus.enabled,
      }
    },
    onPressedActiveUpdatePaymentSchedule(row) {
      this.paymentScheduleModal = {
        active: true,
        type: 'update',
        title: 'แก้ไขข้อมูลกำหนดการนัดชำระเงิน',
        id: row.id,
        paymentDate: moment(row.paymentDate).format('DD-MM-YYYY'),
        paymentAmount: row.paymentAmount,
        paymentRemark: row.paymentRemark,
        status: row.status,
      }
    },
    async onPressedAcceptPaymentSchedule() {
      const vm = this
      const contractId = this.$route.params.id;
      const {createContractDetailPaymentSchedule, updateContractDetailPaymentSchedule} = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const paymentDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentScheduleModal.paymentDate.trim())
        const form = {
          paymentDate,
          paymentAmount: parseFloat(vm.paymentScheduleModal.paymentAmount),
          paymentRemark: vm.paymentScheduleModal.paymentRemark,
          status: vm.paymentScheduleModal.status,
        }
        if (vm.paymentScheduleModal.type === 'add') {
          await createContractDetailPaymentSchedule({
            contractId,
            form,
          });
        } else if (vm.paymentScheduleModal.type === 'update') {
          await updateContractDetailPaymentSchedule({
            id: vm.paymentScheduleModal.id,
            form,
          })
        }
        vm.paymentScheduleModal.active = false;
      })
    },
    async onPressedDelPaymentSchedule(id) {
      const vm = this
      const {deleteContractDetailPaymentSchedule} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลกำหนดการนัดชำระเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailPaymentSchedule({
            id,
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-status {
  width: 120px;
}

.col-processed {
  width: 140px;
}

.col-actions {
  width: 120px;
}

.custom-popup .vs-popup {
  width: 700px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
